// TopBarV2 (SaaS) — bản ĐẤU NỐI của host cho vỏ dùng chung @cnv/ui/layout/TopBarV2.
//
// Vỏ (cnv-ui) lo logo + breadcrumb + ô tìm kiếm ⌘K. File này lo phần RIÊNG của SaaS:
//   - breadcrumb: getBreadcrumbs(menu, path) — cnv-ui nhận (menu, path), Core nhận (path)
//   - gói đang dùng: PlanBadgeV2 (gói + số chỗ + hạn), bấm ra Kho ứng dụng.
//   - avatar: dùng LẠI UserMenu của cnv-ui, đưa lên thanh trên chỉ bằng CSS (ui-v2.css lật
//     neo popup từ bottom-left sang top-right), KHÔNG sửa file dùng chung với Core. Dưới
//     1024px thanh này bị ẩn nên avatar hiện ở đáy rail — do RailBottomV2.jsx lo.
//     Popup đó chứa cả ngôn ngữ lẫn giao diện sáng/tối.
// 15/08: BỎ nút Xuất file + bộ chọn ngôn ngữ khỏi thanh (sếp Phú) — xem chú thích trong JSX.
// Công tắc v1/v2 KHÔNG ở đây: sếp Phú chốt 14/08 dời xuống đáy menu trái.

import { useLocation } from 'react-router-dom';
import { getBreadcrumbs } from '@cnv/ui/navigation/menuUtils';
import TopBarShell from '@cnv/ui/layout/TopBarV2';
import TopBarCallButton from '@cnv/ui/layout/TopBarCallButton';
import UserMenu from '@cnv/ui/layout/sidebar/UserMenu';
import ProductNewsBell from '@cnv/ui/product-news/ProductNewsBell';
import HelpMenu from '@cnv/ui/support-help/HelpMenu';
import PlanBadgeV2 from './PlanBadgeV2';
import WorkspaceSwitcherV2 from './WorkspaceSwitcherV2';

export default function TopBarV2({ menu = [], brand = {} }) {
  const location = useLocation();
  const crumbs = getBreadcrumbs(menu, location.pathname) || [];

  return (
    // `workspace` là slot của vỏ, đứng ngay sau tên app: workspace là NGỮ CẢNH của cả trang
    // (mọi dữ liệu bên dưới thuộc về nó) nên phải nằm cùng cụm định danh bên trái, trước
    // gạch phân cách và breadcrumb. Core truyền rỗng — bản cài riêng không có gì để đổi.
    <TopBarShell brand={brand} crumbs={crumbs} workspace={<WorkspaceSwitcherV2 />}>
      {/* Gói đang dùng + số chỗ + hạn — sếp Phú 15/08 muốn thấy ngay trên thanh, không phải
          mở /marketplace mới biết. Đứng trước avatar: mắt đọc trái→phải là gói → avatar. */}
      <PlanBadgeV2 />

      {/* Gọi điện (17/08) — lối vào bàn phím quay số dời từ nút nổi góc phải-dưới lên đây,
          chung một component với Core. Widget tự bỏ nút nổi khi đang ở v2 nên không có hai
          nút cùng chức năng. Tự ẩn với tenant/user không có máy nhánh. */}
      <TopBarCallButton />

      {/* Trợ giúp (13/10/2026, thay «Trợ giúp AI» 07/09) — cụm DÙNG CHUNG Site Connect (@cnv/ui
          support-help): Chat với hỗ trợ (trợ lý AI + người trực) · Gửi góp ý / Báo lỗi · Yêu cầu của
          workspace · Trung tâm trợ giúp + thông báo yêu cầu có cập nhật. Đứng cạnh nút gọi vì cùng họ
          "gọi người giúp"; bong bóng mặc định của widget đã ẩn để chỉ còn MỘT lối vào. */}
      <HelpMenu />

      {/* Chuông «Tin mới» (29/09) — tính năng mới / cải tiến / thông báo từ CNV. Bài soạn ở Core, Work
          giữ bản sao do cron product_news.sync kéo về. Cùng component với Core. */}
      <ProductNewsBell />

      {/* Sếp Phú 15/08: bỏ nút Tải xuống và bộ chọn ngôn ngữ khỏi thanh trên cùng.
          — Ngôn ngữ: KHÔNG mất chức năng, UserMenu (popup avatar) đã có sẵn bộ chọn.
          — Tải xuống: lối tắt + badge "file xuất xong chưa tải" bỏ theo. Trang vẫn vào được
            qua menu Tiện ích → Xuất file, nhưng người dùng sẽ KHÔNG còn được nhắc khi file
            xuất xong. Đây là đánh đổi có chủ ý, không phải sót.
          Popup avatar giờ gánh cả ngôn ngữ lẫn giao diện sáng/tối. */}
      <span className="v2-topbar__user">
        <UserMenu />
      </span>
    </TopBarShell>
  );
}
